var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "reconciliation-step-template",
    {
      attrs: { nextStep: _vm.nextStep, previousStep: _vm.previousStep },
      on: {
        next: _vm.goToNextStep,
        previous: function($event) {
          return _vm.$emit("previous")
        }
      }
    },
    [
      _c("template", { slot: "content" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$l10n.__("Crédit - Débit sans type")))]),
        _vm._v(" "),
        _c("p", { staticClass: "fs-3" }, [
          _vm._v(
            _vm._s(
              _vm.$l10n.__(
                "Définissez maintenant la colonne comportant l'indication de type de transaction."
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            { staticClass: "step-container-table border-black" },
            [
              _c("table-selectable-columns", {
                attrs: { lines: _vm.csv, max: 1 },
                model: {
                  value: _vm.value.template.type_from_string.columns,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.value.template.type_from_string,
                      "columns",
                      $$v
                    )
                  },
                  expression: "value.template.type_from_string.columns"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("p", { staticClass: "fs-3 mt-4 mb-2" }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Quels sont les caractères pour désigner les crédits?"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("text-input", {
                attrs: { mode: "edit" },
                model: {
                  value: _vm.value.template.type_from_string.arguments.credit,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.value.template.type_from_string.arguments,
                      "credit",
                      $$v
                    )
                  },
                  expression: "value.template.type_from_string.arguments.credit"
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "fs-3 mt-4 mb-2" }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Quels sont les caractères pour désigner les débits ?"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("text-input", {
                attrs: { mode: "edit" },
                model: {
                  value: _vm.value.template.type_from_string.arguments.debit,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.value.template.type_from_string.arguments,
                      "debit",
                      $$v
                    )
                  },
                  expression: "value.template.type_from_string.arguments.debit"
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }